import { render, staticRenderFns } from "./digits-input.vue?vue&type=template&id=f1393f22"
import script from "./digits-input.vue?vue&type=script&lang=js"
export * from "./digits-input.vue?vue&type=script&lang=js"
import style0 from "./digits-input.vue?vue&type=style&index=0&id=f1393f22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports